module.exports = __webpack_public_path__ + "img/default-worth.52122e8e.png";